import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, Input, Signal} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SpinnerService, SpinnerState} from './spinner.service';

function getSpinnerState(): Signal<SpinnerState> {
  return inject(SpinnerService).spinnerState;
}

@Component({
  selector: 'app-spinner',
  template: `
    <div
      class="spinner"
      [ngClass]="{
        'spinner--hidden': !spinnerState().show,
        'spinner--changelogs': inputStyle === 'changelogs'
      }"
      [ngStyle]="{
        width: width ? width : '100%',
        height: height ? height : '100%',
        background: background ? background : 'rgba(255,255,255,0.8)'
      }">
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="diameter ? diameter : 200"></mat-progress-spinner>
    </div>
  `,
  styles: [
    `
      .spinner {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        z-index: 1000;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
      }

      .spinner--hidden {
        display: none;
      }

      .spinner--changelogs {
        align-items: start;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule]
})
export class SpinnerComponent {
  @Input() diameter: number;
  @Input() inputStyle: string;
  @Input() height: string;
  @Input() width: string;
  @Input() background: string;

  public spinnerState = getSpinnerState();
}
